import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const loadingOverlayFn = /* @__PURE__ */ createRecipe('loading-overlay', {}, [])

const loadingOverlayVariantMap = {}

const loadingOverlayVariantKeys = Object.keys(loadingOverlayVariantMap)

export const loadingOverlay = /* @__PURE__ */ Object.assign(memo(loadingOverlayFn.recipeFn), {
  __recipe__: true,
  __name__: 'loadingOverlay',
  __getCompoundVariantCss__: loadingOverlayFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: loadingOverlayVariantKeys,
  variantMap: loadingOverlayVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, loadingOverlayVariantKeys)
  },
  getVariantProps: loadingOverlayFn.getVariantProps,
})